import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { CallLog } from '@/types/models/CallLog';

type Filters =
  | {
      reservation_id?: number | null;
    }
  | undefined;
const useCallLogs = (enabled: boolean = true, filters: Filters = undefined) => {
  const client = supabaseClient;
  const queryKey = ['call_logs', filters?.reservation_id];

  const queryFn = async () => {
    return getCallLogs(client, filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useCallLogs;

function getCallLogs(client: SupabaseClient, filters: Filters): CallLog[] {
  let clientWithFilters = client
    .from('call_logs')
    .select(
      `
        id,
        reservation_id ( id, client, restaurant_id ( id, name, address, phone, created_at ), phone, date, people, status, created_at ),
        channel,
        duration,
        date,
        about,
        created_at,
        phone
      `
    )
    .order('date', { ascending: true });

  if (filters?.reservation_id) {
    clientWithFilters = clientWithFilters.eq('reservation_id', filters.reservation_id);
  }

  return clientWithFilters.then((result: any) => result.data) as unknown as CallLog[];
}
